import React, { useState, useEffect } from 'react';
import { compose } from 'redux-starter-kit';
import { connect } from 'react-redux';
import Store from 'store/store';
import api from 'api';
import ScatterChart from './ScatterChart';

import { makeStyles, CircularProgress } from '@material-ui/core';
import {
  CachedDataType,
  PastPerformanceType
} from 'store/modules/InvestmentAnalyser/types';
import { getCachableData } from './utils';

const { selectors } = Store;

const useStyles = makeStyles({
  loaderWrapper: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    height: '100%',
    minHeight: '25rem'
  }
});

interface ScatterChartTabProps {
  investments: any;
  riskRatings: CachedDataType;
  pastPerformanceCacheIsValid: boolean;
  selectedInvestment: number;
  pastPerformance: PastPerformanceType;
  provider?: any;
  range?: any;
}

const ScatterChartTab = ({
  investments,
  riskRatings,
  pastPerformanceCacheIsValid,
  selectedInvestment,
  pastPerformance,
  provider = null,
  range = null
}: ScatterChartTabProps) => {
  const classes = useStyles();
  const [tabularData, setTabularData] = useState(
    pastPerformance.tabularData || []
  );
  const [isLoading, setIsLoading] = useState(!riskRatings.investments.length);

  useEffect(() => {
    if (!selectedInvestment && !provider) return;
    getCachableData(
      investments,
      pastPerformanceCacheIsValid,
      setIsLoading,
      selectedInvestment
        ? () => api.getResearchItemPastPerformance({ id: selectedInvestment })
        : () =>
            api.getMpsHubPastPerformance({
              provider: provider.id,
              range: range
            }),
      (response: any) => setTabularData(response.data.tabular_data)
    );
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [investments]);

  return (
    <>
      {isLoading ? (
        <div className={classes.loaderWrapper}>
          <CircularProgress size="80px" />
        </div>
      ) : (
        <div style={{ marginTop: '2rem' }}>
          <ScatterChart data={investments} performanceData={tabularData} />
        </div>
      )}
    </>
  );
};

export default compose(
  connect((state: any) => ({
    investments:
      selectors.investmentAnalyserSelectors.checkedResearchInvestments(state),
    riskRatings: selectors.investmentAnalyserSelectors.riskRatings(state),
    pastPerformance:
      selectors.investmentAnalyserSelectors.pastPerformance(state),
    pastPerformanceCacheIsValid:
      selectors.investmentAnalyserSelectors.pastPerformanceCacheIsValid(state)
  }))
)(ScatterChartTab);
